import { render, staticRenderFns } from "./ReportsCall.vue?vue&type=template&id=4d63f55e"
import script from "./ReportsCall.vue?vue&type=script&lang=js"
export * from "./ReportsCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports